import { getDateFilter } from "@flexibees/core";
import { API } from "../constants/api";
import {
  axiosGetWithToken,
  axiosPostWithToken,
  axiosPut,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";

export const PROJECT_LAUNCH_LIST = "PROJECT_LAUNCH_LIST";
export const PROJECT_LAUNCH_LOADER = "PROJECT_LAUNCH_LOADER";
export const SEARCH_JOBS = "SEARCH_JOBS";
export const CHANGE_CURRENT_PROJECT_PAGE = "CHANGE_CURRENT_PROJECT_PAGE";
export const SET_PROJECT_ITEMS_PER_PAGE = "SET_PROJECT_ITEMS_PER_PAGE";
export const PROJECT_STATUS_FILTER = "PROJECT_STATUS_FILTER";
export const GET_RECRUITMENT = "GET_RECRUITMENT";
export const SET_RECRUITMENT_ITEMS_PER_PAGE = "SET_RECRUITMENT_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_RECRUITMENT_PAGE =
  "CHANGE_CURRENT_RECRUITMENT_PAGE";
export const GET_WORKFLOW_FINAL = "GET_WORKFLOW_FINAL";
export const SET_WORKFLOW_FINAL_ITEMS_PER_PAGE =
  "SET_WORKFLOW_FINAL_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_WORKFLOW_FINAL_PAGE =
  "CHANGE_CURRENT_WORKFLOW_FINAL_PAGE";
export const VIEW_LAUNCH_DETAILS = "VIEW_LAUNCH_DETAILS";
export const CHANGE_VIEW_LAUNCH_TAB = "CHANGE_VIEW_LAUNCH_TAB";
export const PROJECT_RENEWAL_LOADER = "PROJECT_RENEWAL_LOADER";
export const PROJECT_RENEWAL_LIST = "PROJECT_RENEWAL_LIST";
export const SET_PROJECT_LAUNCH_DATE_FILTER = "SET_PROJECT_LAUNCH_DATE_FILTER";
export const CLEAR_PROJECT_LAUNCH_DATE_FILTER =
  "CLEAR_PROJECT_LAUNCH_DATE_FILTER";

export const PROJECT_PAYMENTS_LIST = "PROJECT_PAYMENTS_LIST";

const buildStatusFilter = (statusus) => {
  if (statusus.length === 1) return { status: String(statusus[0]) };
  if (statusus.length > 1) return { statusus: statusus.map(String) };
  return {};
};



export const getProjectLauchList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const { projectLaunch } = getState();
    const {
      projectLaunchCurrentPage: pageNumber,
      projectLaunchSearchText: searchText,
      projectLaunchStatusFliter: statusus,
      dateFilters 
    } = projectLaunch;



    const bodyData = {
      search: searchText,
      page_no: pageNumber,
      ...buildStatusFilter(statusus),
    };

      Object.entries(dateFilters).forEach(([key, value]) => {
      if (value?.length === 2) {
        bodyData[key] = value;
      }
    });

    axiosPostWithToken(API.PROJECT_LAUNCH_LIST, bodyData, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({ type: PROJECT_LAUNCH_LIST, payload: res.data.data });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: SET_PROJECT_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: CHANGE_CURRENT_PROJECT_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: SEARCH_JOBS,
      payload: value,
    });
  };
};

export const editNotes = (id, data, refresh) => {
  const payload = { notes: data };
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPostWithToken(`${API.EDIT_PROJECT_NOTES}/${id}`, payload, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: PROJECT_LAUNCH_LOADER,
          });
          refresh();
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Notes updated Successfully",
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      },
    );
  };
};

export const setProjectStatusFliter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: PROJECT_STATUS_FILTER,
      payload: value,
    });
  };
};

export const exportProjectData = (fromDate, toDate) => {
  return async (dispatch, getState) => {
    dispatch({ type: PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const pageNumber = getState().projectLaunch.projectLaunchCurrentPage;
    const searchText = getState().projectLaunch.projectLaunchSearchText;
    const statusus = getState().projectLaunch.projectLaunchStatusFliter;

    const bodyData = {
      search: searchText,
      page_no: pageNumber,
      from: fromDate,
      to: toDate,
    };

    if (statusus.length === 1) {
      bodyData.status = String(statusus[0]);
    } else if (statusus.length > 1) {
      bodyData.statusus = statusus.map(String);
    }

    const apiUrl = `${API.PROJECT_DETAILS_DOWNLOAD}`;

    axiosPostWithToken(apiUrl, bodyData, token, {
      responseType: "blob",
    })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "project-data.csv");
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err?.response?.data || "Something went wrong.",
        });
      });
  };
};

export const getRecruitment = (currentPage) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize = getstate().recruit.recruitmentResultsPerPage;
    const page = currentPage;
    const seachText = getstate().recruit.recruitmentSearchText;
    const functions = getstate().recruit.recruitmentAppliedFunctionFilter;
    const roles = getstate().recruit.recruitmentAppliedRolesFilter;
    const status = getstate().recruit.recruitmentAppliedStatusFilter;
    const recruiters = getstate().recruit.recruitmentAppliedRecruiterFilter;
    const bdManager = getstate().recruit.recruitmentAppliedBDManagerFilter;
    const no_of_days = getstate().recruit.recruitmentAppliedNoOfDaysFilter;
    const date = getDateFilter(
      getstate().recruit.recruitmentAppliedDateFilter[0],
    );

    const body = {
      search_term: seachText,
      filter_data: {
        functions: functions,
        roles: roles,
        status: status,
        recruiters: recruiters,
        start_date: date,
        bd_managers: bdManager,
        no_of_days: no_of_days,
      },
    };

    axiosPostWithToken(
      `${API.GET_RECRUITMENT}/${pagesize}/${page}/`,
      body,
      token,
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_RECRUITMENT,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to fetch data.",
        });
      }
    });
  };
};

export const loadMoreRecruitment = () => {
  return (dispatch, getState) => {
    const currentPage = getState().recruit.recruitmentCurrentPage;
    const totalPages = getState().recruit.recruitmentTotalPages;

    if (currentPage < totalPages) {
      dispatch({
        type: CHANGE_CURRENT_RECRUITMENT_PAGE,
        payload: currentPage + 1,
      });

      dispatch(getRecruitment()); // same API call, but now next page
    }
  };
};

export const getCandidateList = () => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize = getstate().recruit.recruitmentResultsPerPage;
    const page = getstate().recruit.recruitmentCurrentPage;
    const seachText = getstate().recruit.recruitmentSearchText;
    const functions = getstate().recruit.recruitmentAppliedFunctionFilter;
    const roles = getstate().recruit.recruitmentAppliedRolesFilter;
    const status = getstate().recruit.recruitmentAppliedStatusFilter;
    const recruiters = getstate().recruit.recruitmentAppliedRecruiterFilter;
    const bdManager = getstate().recruit.recruitmentAppliedBDManagerFilter;
    const no_of_days = getstate().recruit.recruitmentAppliedNoOfDaysFilter;
    const date = getDateFilter(
      getstate().recruit.recruitmentAppliedDateFilter[0],
    );

    const body = {
      search_term: seachText,
      filter_data: {
        functions: functions,
        roles: roles,
        status: status,
        recruiters: recruiters,
        start_date: date,
        bd_managers: bdManager,
        no_of_days: no_of_days,
      },
    };

    axiosPostWithToken(
      `${API.GET_RECRUITMENT}/${pagesize}/${page}/`,
      body,
      token,
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_RECRUITMENT,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Unable to fetch data.",
        });
      }
    });
  };
};

export const getFinal = (projectId) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize = getstate().recruit.workflowFinalResultsPerPage;
    const page = getstate().recruit.workflowFinalCurrentPage;
    const seachText = getstate().recruit.workflowFinalSearchText;
    const roles = getstate().recruit.workflowFinalAppliedRolesFilter;
    const skills = getstate().recruit.workflowFinalAppliedSkillsFilter;
    const status = getstate().recruit.workflowFinalAppliedStatusFilter;
    const minRelExp = getstate().recruit.workflowFinalAppliedMinRelExpFilter;
    const maxRelExp = getstate().recruit.workflowFinalAppliedMaxRelExpFilter;
    const minTotalExp =
      getstate().recruit.workflowFinalAppliedMinTotalExpFilter;
    const maxTotalExp =
      getstate().recruit.workflowFinalAppliedMaxTotalExpFilter;
    const matching =
      getstate().recruit.workflowFinalAppliedMatchingFilter === "0"
        ? false
        : true;
    const total_available_hours =
      getstate().recruit.workflowFinalAppliedAvailableHoursFilter;

    const flexibees_selected =
      getstate().recruit.candidatesListApplaiedFilterFlexiSelected;
    const active_projects =
      getstate().recruit.candidatesListApplaiedFilterActiveProjects;

    const body = {
      search_term: seachText,
      filter_data: {
        roles: roles,
        skills: skills,
        status: status,
        final_selection: matching,
        flexibees_selected: flexibees_selected,
        active_projects: active_projects,
        relevant_experience: {
          min: minRelExp,
          max: maxRelExp,
        },
        years_of_experience: {
          min: minTotalExp,
          max: maxTotalExp,
        },
        total_available_hours: total_available_hours,
      },
    };

    axiosPostWithToken(
      `${API.GET_WORKFLOW_FINAL}/${projectId}/${pagesize}/${page}/`,
      body,
      token,
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_WORKFLOW_FINAL,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to fetch data.",
        });
      }
    });
  };
};

export const createLaunchProject = (id, data, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    const payload = {
      latest_start_date: data?.starting_date,
      latest_project_hours: data?.working_hours,
      status: data?.status,
      notes: data?.notes,
    };
    axiosPostWithToken(
      `${API.CREATE_PROJECT_LAUNCH}${id}/`,
      payload,
      token,
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: PROJECT_LAUNCH_LOADER,
        });
        refresh();
        dispatch({
          type: SUCCESS_ALERT,
          payload: res.data.data.message || "Successfully updated",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Error updating User.",
        });
      }
    });
  };
};

export const updateDetails = (id, data, refresh) => {
  const payload = { ...data };

  // --- DATE FIELDS (must update when cleared) ---
  const dateFields = [
    "latest_start_date",
    "termination_date",
    "tentative_end_date",
    "original_end_date",
  ];

  dateFields.forEach((field) => {
    // Convert empty string or undefined to null
    if (payload[field] === "" || payload[field] === undefined) {
      payload[field] = null;
    }
  });

  // --- HOURS (append "hours per day" if missing) ---
  if (
    payload.latest_project_hours &&
    payload.latest_project_hours.trim() !== "" &&
    !payload.latest_project_hours.toLowerCase().includes("hours per day")
  ) {
    payload.latest_project_hours = `${payload.latest_project_hours} hours per day`;
  }

  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(
      `${API.UPDATE_PROJECT_LAUNCH}/${id}/`,
      payload,
      token,
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: PROJECT_LAUNCH_LOADER,
        });

        refresh();

        dispatch({
          type: SUCCESS_ALERT,
          payload: "Notes updated Successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Error updating User.",
        });
      }
    });
  };
};

export const createProjectRenewal = (id, data, history, path) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    const payload = {
      renewal_period: data?.duration,
      new_client_pricing: data?.new_client_pricing,
      new_candidate_pricing: data?.new_candidate_pricing,
      new_project_hours: data?.working_hours,
      status: data?.status,
    };

    if (data?.renewal_date) {
      payload.date_of_renewal = data?.renewal_date;
    }

    axiosPostWithToken(
      `${API.CREATE_PROJECT_RENEWALS}${id}/`,
      payload,
      token,
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: PROJECT_LAUNCH_LOADER,
        });

        dispatch({
          type: SUCCESS_ALERT,
          payload: res.data.data.message || "Successfully updated",
        });
        history.push(`${path}/detail/${id}`);
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            res.data.data.message ||
            "Something went wrong. Error updating User.",
        });
      }
    });
  };
};

export const viewLaunchDetails = (id, disableLoader) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosGetWithToken(`${API.PROJECT_LAUNCH_DETAILS}/${id}/`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: VIEW_LAUNCH_DETAILS,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const changeviewProjectTab = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CHANGE_VIEW_LAUNCH_TAB,
      payload: id,
    });
  };
};

export const getProjectRenewalList = (launchId) => {
  return async (dispatch, getState) => {
    dispatch({ type: PROJECT_RENEWAL_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.PROJECT_RENEWALS_LIST}${launchId}/`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const apiData = res?.data?.data || []; // direct array access
        if (statusCode === 200 && Array.isArray(apiData)) {
          dispatch({
            type: PROJECT_RENEWAL_LIST,
            payload: apiData,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load renewals.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching renewals.",
        });
      });
  };
};

export const updateRenewal = (launchId, data, id) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.UPDATE_RENEWALS}${launchId}/`;

    const bodyData = {
      ...(data.renewal_date && { date_of_renewal: data.renewal_date }),
      ...(data.duration && { renewal_period: data.duration }),
      ...(data.new_client_pricing && {
        new_client_pricing: data.new_client_pricing,
      }),
      ...(data.new_candidate_pricing && {
        new_candidate_pricing: data.new_candidate_pricing,
      }),
      ...(data.working_hours && { new_project_hours: data.working_hours }),
      ...(data.status && { status: data.status }),
    };

    axiosPut(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Renewal updated successfully.",
          });
          dispatch(getProjectRenewalList(id));
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to Update Renewal.",
          });
        }
      })
      .catch((err) => {
        console.error(
          "Renewal Update Error:",
          err.response?.data || err.message,
        );
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while updating the Renewal.",
        });
      });
  };
};

export const exportTransactionOrMaster = (launch_type, billingMonth, mode) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    const bodyData = {
      launch_type: launch_type,
      ...(mode === "Transactions" && { billing_month: billingMonth }),
    };

    const apiUrl = mode === "Transactions" ? API.EXPORT_TRANSACTION : API.EXPORT_MASTER;

    try {
      const response = await axiosPostWithToken(apiUrl, bodyData, token, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: response.headers?.["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const disposition = response.headers?.["content-disposition"];
       const formattedDate = new Date().toISOString().split("T")[0];
      let filename = `Tally_${launch_type}-${mode}-${billingMonth || formattedDate}` ;
      if (disposition) {
        const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
        if (match?.[1]) filename = decodeURIComponent(match[1]);
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      console.error("Export failed:", error);
      throw error;
    }
  };
};

export const getProjectPaymentList = (launchId) => {
  return async (dispatch, getState) => {

    const token = getState().auth.token;
    const apiUrl = `${API.PROJECT_PAYMENTS_LIST}${launchId}/`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const apiData = res?.data?.data || []; // direct array access
        if (statusCode === 200 && Array.isArray(apiData)) {
          dispatch({
            type: PROJECT_PAYMENTS_LIST,
            payload: apiData,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load payments.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching renewals.",
        });
      });
  };
};
